import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useNavigate } from "react-router-dom";
import apiClient from "./api/apiClient";

const Meetings = () => {
  const [meetings, setMeetings] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const userId = localStorage.getItem("userId");
    if (userId) {
      const fetchMeetings = async () => {
        try {
          const response = await apiClient.get(`/meetings/initiator/${userId}`);
          console.log("Meetings response is ",response.data);
          setMeetings(response.data);
        } catch (error) {
          console.error("Error fetching meetings:", error);
        }
      };

      fetchMeetings();
    }
  }, []);

  const handleEdit = (meetingId) => {
    navigate(`/editmeeting/${meetingId}`);
  };

  const handleJoin = (roomId, meetingId) => {
    navigate(`/meetingroom/${roomId}/${meetingId}`,{state:{isInitiator:true}});
  };

  const handleAddMeeting = () => {
    navigate("/createmeeting");
  };

  return (
    <div style={{ padding: "20px" }}>
      <Typography variant="h5" gutterBottom>
        Meetings
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={handleAddMeeting}
        style={{ marginBottom: "10px" }}
      >
        Add Meeting
      </Button>

      <TableContainer component={Paper} style={{ maxHeight: 400 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>ID</TableCell>
              <TableCell>Title</TableCell>
              <TableCell>Start Time</TableCell>
              <TableCell>Invitee</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {meetings.map((meeting) => (
              <TableRow key={meeting.id}>
                <TableCell>{meeting.id}</TableCell>
                <TableCell>{meeting.title}</TableCell>
                <TableCell>{new Date(meeting.scheduledAt).toLocaleString()}</TableCell>
                <TableCell>{meeting.inviteeName || "-"}</TableCell>
                <TableCell align="center">
                  <Stack direction="row" spacing={1} justifyContent="center">
                    <IconButton onClick={() => handleEdit(meeting.id)} title="Edit">
                      <EditIcon />
                    </IconButton>
                    <Button
                      variant="contained"
                      color="secondary"
                      onClick={() => handleJoin(meeting.roomId, meeting.id)}
                    >
                      Join
                    </Button>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
            {meetings.length === 0 && (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No meetings found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
};

export default Meetings;
